import React from 'react';
import './Hero.css';

const Hero = () => {
     return (
          <div className="bgImage">
               <h2 className="font-bigilla text-[#F7F6F2] text-[22vw] flex justify-center items-center w-screen h-screen">I CAM</h2>
          </div>
     );
};

export default Hero;